<template>
  <div id="">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height class="gradientBack">
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-toolbar color class="mb-3 bords gradientTop">
                <v-toolbar-title class="mx-auto">RESET PASSWORD</v-toolbar-title>
              </v-toolbar>
              <v-card class="elevation-12">
                <v-form @submit.prevent="handleSubmit(email)">
                  <v-card-text>
                    Enter your email to reset your password.
                    <v-text-field
                      prepend-icon="person"
                      name="e-mail address"
                      label="E-mail address"
                      type="email"
                      v-model="email"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn block class="gradientBottomL bords" large type="submit">Reset password</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import resetService from "@/_services/reset.service";
export default {
  data() {
    return {
      email: ""
    };
  },
  methods: {
    handleSubmit(email) {
      
      this.$store.dispatch("authentication/resetPassword", email);
    }
  }
};
</script>


<style lang="scss" scoped>
.gradientBack {
  background: radial-gradient(#81be6f, #50b6e5) !important;
}
.gradientBottomL {
  background: linear-gradient(0.25turn, rgb(119, 186, 134));
}
.gradientBottomR {
  color: #50b6e5 !important;
}
.bords,
.elevation-12 {
  border-radius: 0.3rem !important;
}
.fonts {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
</style>
